import type { IColorUser } from '@/Auth/ColorUser';
import type { UserPermission } from '@/Auth/types';

import { hasRole } from '../Roles';

import type { IAuthorizationProps } from './types';

function hasPermissions(user: IColorUser, permissions: UserPermission[]): boolean {
  return permissions.every((permission) => Boolean(user.permissions[permission]));
}

export function isUserAuthorized(
  currentUser: IColorUser | undefined,
  authProps: IAuthorizationProps
): boolean {
  const { allowedRoles = [], requiredPermissions = [], signedOutUserIsAllowed = false } = authProps;

  if (currentUser) {
    const userHasAllowedRoles = allowedRoles.some(
      (role) =>
        hasRole(currentUser, role) ||
        currentUser.dependents.some((dependent) => hasRole(dependent, role))
    );
    const userHasPermissions = hasPermissions(currentUser, requiredPermissions);

    if (allowedRoles.length > 0 && requiredPermissions.length > 0) {
      throw new Error('Both roles and permissions are specified.  You likely only want one set.');
    } else if (allowedRoles.length > 0) {
      return userHasAllowedRoles;
    } else if (requiredPermissions.length > 0) {
      return userHasPermissions;
    }
    return true;
  }
  return signedOutUserIsAllowed;
}
